import { OPEN_MODAL_INSERIMENTO } from 'types/actions';

export const OpenModal = element => ({
    type: OPEN_MODAL_INSERIMENTO,
    element
});
  